import { IonButton, IonCol, IonFooter, IonGrid, IonIcon, IonLabel, IonRow, IonSelect, IonSelectOption, IonToolbar } from '@ionic/react';
import {arrowDropleft, arrowDropright} from 'ionicons/icons';
import { useAuthentication } from '../../authentication/authentication-hook';

export const PaginatedFooter = ({
  currentPageNumber,
  itemsCount,
  pageLimit,
  onPageChange,
  isLoading,
}) => {
  const totalPages = Math.ceil(itemsCount / pageLimit);
  const { isLoggedIn } = useAuthentication();

  return (
    <IonFooter>
      {totalPages > 1 && (
        <IonToolbar>
          <IonGrid>
            <IonRow
              className={`ion-align-items-center ion-justify-content-between ${
                isLoading ? 'pagination-disabled' : ''
              }`}
            >
              <IonCol size='2'>
                <IonButton
                  expand='block'
                  disabled={currentPageNumber === 1 || isLoading}
                  onClick={() => onPageChange(currentPageNumber - 1)}
                  color='fern'
                >
                  <IonIcon icon={arrowDropleft} size='medium' />
                </IonButton>
              </IonCol>

              <IonCol size='8' className='ion-text-center'>
                <IonGrid className='pagination-center'>
                  <IonRow class='ion-align-items-center'>
                    <IonCol>
                      <IonSelect
                        value={currentPageNumber}
                        interface='popover'
                        disabled={isLoading}
                        onIonChange={(e) => {
                          const page = Number(e.detail.value);
                          if (page !== currentPageNumber) {
                            onPageChange(page);
                          }
                        }}
                      >
                        {Array.from({ length: totalPages }, (_, i) => {
                          const page = i + 1;
                          return (
                            <IonSelectOption key={page} value={page}>
                              {page}
                            </IonSelectOption>
                          );
                        })}
                      </IonSelect>
                    </IonCol>

                    <IonCol>
                      <IonLabel className='pagination-total'>
                        <h2>of {totalPages}</h2>
                      </IonLabel>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonCol>

              <IonCol size='2'>
                <IonButton
                    expand='block'
                    disabled={currentPageNumber === totalPages || isLoading}
                    onClick={() => onPageChange(currentPageNumber + 1)}
                    color='fern'
                >
                  <IonIcon icon={arrowDropright} size='medium'/>
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      )}
    </IonFooter>
  );
};
